import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, Teleport as _Teleport, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/ai-brain.svg'


const _hoisted_1 = { class: "group-chat__banner" }
const _hoisted_2 = { class: "group-chat__conversations" }
const _hoisted_3 = { class: "group-chat__conversation-actions" }
const _hoisted_4 = {
  key: 0,
  class: "group-chat__new-chat"
}
const _hoisted_5 = {
  key: 0,
  class: "group-chat__loading"
}
const _hoisted_6 = {
  key: 1,
  class: "group-chat__loading"
}
const _hoisted_7 = {
  key: 2,
  class: "group-chat__empty"
}
const _hoisted_8 = { class: "group-chat__event-time" }
const _hoisted_9 = { class: "group-chat__meta" }
const _hoisted_10 = {
  key: 0,
  class: "group-chat__author group-chat__author--bot"
}
const _hoisted_11 = {
  key: 1,
  class: "group-chat__author"
}
const _hoisted_12 = { class: "group-chat__time" }
const _hoisted_13 = {
  key: 0,
  class: "group-chat__text"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { key: 1 }
const _hoisted_16 = {
  key: 1,
  class: "group-chat__sources"
}
const _hoisted_17 = { class: "group-chat__action-header" }
const _hoisted_18 = { class: "group-chat__action-summary" }
const _hoisted_19 = {
  key: 0,
  class: "group-chat__action-state group-chat__action-state--sent"
}
const _hoisted_20 = {
  key: 1,
  class: "group-chat__action-state group-chat__action-state--cancelled"
}
const _hoisted_21 = {
  key: 2,
  class: "group-chat__action-state group-chat__action-state--expired"
}
const _hoisted_22 = {
  key: 0,
  class: "group-chat__action-buttons"
}
const _hoisted_23 = { class: "group-chat__action-devices" }
const _hoisted_24 = {
  key: 0,
  class: "group-chat__action-hint"
}
const _hoisted_25 = {
  key: 1,
  class: "group-chat__action-hint"
}
const _hoisted_26 = { class: "group-chat__action-fields" }
const _hoisted_27 = { class: "group-chat__action-field-label" }
const _hoisted_28 = { class: "group-chat__action-field-current" }
const _hoisted_29 = { key: 2 }
const _hoisted_30 = {
  key: 0,
  class: "group-chat__action-typed"
}
const _hoisted_31 = { class: "group-chat__action-buttons" }
const _hoisted_32 = {
  key: 4,
  class: "group-chat__action-error"
}
const _hoisted_33 = {
  key: 2,
  class: "group-chat__attachment"
}
const _hoisted_34 = ["alt", "src", "onClick"]
const _hoisted_35 = {
  key: 0,
  class: "group-chat__attachment-image-loading"
}
const _hoisted_36 = {
  key: 1,
  class: "group-chat__attachment-image-loading"
}
const _hoisted_37 = ["onClick"]
const _hoisted_38 = ["title"]
const _hoisted_39 = { class: "group-chat__attachment-size" }
const _hoisted_40 = {
  key: 3,
  class: "group-chat__reactions"
}
const _hoisted_41 = ["title", "onClick"]
const _hoisted_42 = { class: "group-chat__reaction-count" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = {
  key: 3,
  class: "group-chat__typing"
}
const _hoisted_45 = {
  key: 4,
  class: "group-chat__bubble group-chat__bubble--bot"
}
const _hoisted_46 = { class: "group-chat__input" }
const _hoisted_47 = {
  key: 0,
  class: "text-negative q-mb-sm",
  role: "alert"
}
const _hoisted_48 = {
  key: 1,
  class: "group-chat__feedback text-negative q-mb-sm",
  role: "alert"
}
const _hoisted_49 = {
  key: 2,
  class: "group-chat__feedback text-positive q-mb-sm",
  role: "status"
}
const _hoisted_50 = {
  key: 3,
  class: "group-chat__upload-preview"
}
const _hoisted_51 = { class: "group-chat__upload-name" }
const _hoisted_52 = { class: "group-chat__attachment-size" }
const _hoisted_53 = {
  key: 4,
  class: "group-chat__upload-preview"
}
const _hoisted_54 = {
  key: 5,
  class: "group-chat__at-menu"
}
const _hoisted_55 = ["onMousedown"]
const _hoisted_56 = ["src", "alt"]
const _hoisted_57 = {
  key: 0,
  class: "text-white q-pa-sm"
}
const _hoisted_58 = {
  key: 1,
  class: "text-white q-pa-sm"
}
const _hoisted_59 = { class: "group-chat__lightbox-actions" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = {
  key: 0,
  class: "text-negative q-mt-sm",
  role: "alert"
}
const _hoisted_62 = {
  key: 0,
  class: "text-negative q-mt-sm",
  role: "alert"
}
const _hoisted_63 = {
  key: 1,
  class: "text-negative",
  role: "alert"
}
const _hoisted_64 = { key: 2 }
const _hoisted_65 = {
  key: 0,
  class: "text-negative q-mt-sm",
  role: "alert"
}
const _hoisted_66 = { class: "column" }
const _hoisted_67 = { class: "col q-pb-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SupportVideoPlayer = _resolveComponent("SupportVideoPlayer")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_menu = _resolveComponent("q-menu")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_form = _resolveComponent("q-form")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_linear_progress = _resolveComponent("q-linear-progress")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["group-chat", _ctx.viewClass]),
    style: _normalizeStyle(_ctx.detachedStyle)
  }, [
    _createVNode(_component_SupportVideoPlayer, {
      modelValue: _ctx.supportVideoOpen,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.supportVideoOpen) = $event)),
      title: _ctx.supportVideoTitle,
      "source-url": _ctx.supportVideoSourceUrl,
      "get-playback": _ctx.supportVideoPlaybackRequest
    }, null, 8, ["modelValue", "title", "source-url", "get-playback"]),
    _createElementVNode("div", {
      class: "group-chat__header",
      onPointerdown: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.startDetachedDrag && _ctx.startDetachedDrag(...args)))
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["group-chat__title", { 'group-chat__title--flash': _ctx.newMessageFlash }])
      }, _toDisplayString(_ctx.chatTitle), 3),
      _createVNode(_component_q_space),
      (_ctx.viewState === 'collapsed' && _ctx.unreadCount > 0)
        ? (_openBlock(), _createBlock(_component_q_badge, {
            key: 0,
            color: "red",
            floating: "",
            label: _ctx.unreadCount,
            class: "q-mr-sm"
          }, null, 8, ["label"]))
        : _createCommentVNode("", true),
      (_ctx.detached || _ctx.viewState !== 'collapsed')
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 1,
            flat: "",
            dense: "",
            round: "",
            icon: _ctx.detached ? 'keyboard_return' : 'open_in_new',
            size: "sm",
            title: _ctx.detached ? 'Dock chat' : 'Pop out chat',
            onPointerdown: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
            onClick: _withModifiers(_ctx.toggleDetached, ["stop"])
          }, null, 8, ["icon", "title", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.viewState !== 'collapsed')
        ? (_openBlock(), _createBlock(_component_q_btn, {
            key: 2,
            flat: "",
            dense: "",
            round: "",
            icon: "remove",
            size: "sm",
            title: "Minimize",
            onPointerdown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
            onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.viewState = 'collapsed'), ["stop"]))
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_q_btn, {
        flat: "",
        dense: "",
        round: "",
        icon: _ctx.headerIcon,
        size: "sm",
        title: 
          _ctx.viewState === 'collapsed'
            ? 'Open'
            : _ctx.viewState === 'mini'
            ? 'Expand'
            : 'Shrink'
        ,
        onPointerdown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
        onClick: _withModifiers(_ctx.cycleState, ["stop"])
      }, null, 8, ["icon", "title", "onClick"])
    ], 32),
    _withDirectives(_createElementVNode("div", _hoisted_1, " This chat is not visible to users with “viewer” role ", 512), [
      [_vShow, _ctx.viewState !== 'collapsed']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createVNode(_component_q_select, {
        modelValue: _ctx.activeConversationId,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activeConversationId) = $event)),
        dense: "",
        outlined: "",
        "emit-value": "",
        "map-options": "",
        options: _ctx.conversationOptions,
        "popup-content-class": "group-chat__select-menu",
        class: "group-chat__conversation-select"
      }, null, 8, ["modelValue", "options"]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_q_btn, {
          dense: "",
          flat: "",
          icon: "block",
          title: "Blocked users",
          "aria-label": "Blocked users",
          onClick: _ctx.openBlockedUsers
        }, null, 8, ["onClick"]),
        _createVNode(_component_q_btn, {
          dense: "",
          flat: "",
          icon: "person_add",
          title: "New private chat",
          onClick: _ctx.toggleNewConversation
        }, null, 8, ["onClick"]),
        _createVNode(_component_q_btn, {
          dense: "",
          flat: "",
          icon: "smart_toy",
          title: "Propipe AI chat",
          onClick: _ctx.createPropipeAiConversation
        }, null, 8, ["onClick"]),
        (_ctx.canLeaveActiveConversation)
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              dense: "",
              flat: "",
              icon: "logout",
              title: "Leave conversation",
              onClick: _ctx.openLeaveConversationDialog
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      (_ctx.showNewConversation)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_q_select, {
              modelValue: _ctx.selectedParticipantIds,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selectedParticipantIds) = $event)),
              dense: "",
              outlined: "",
              multiple: "",
              "emit-value": "",
              "map-options": "",
              "options-dense": "",
              placeholder: "Select people",
              "display-value": _ctx.selectedParticipantDisplay,
              options: _ctx.participantOptions,
              "popup-content-class": "group-chat__select-menu group-chat__select-menu--participants",
              class: "group-chat__participant-select"
            }, null, 8, ["modelValue", "display-value", "options"]),
            _createVNode(_component_q_btn, {
              dense: "",
              color: "primary",
              label: "Start",
              disable: _ctx.selectedParticipantIds.length === 0,
              onClick: _ctx.createPrivateConversation
            }, null, 8, ["disable", "onClick"])
          ]))
        : _createCommentVNode("", true)
    ], 512), [
      [_vShow, _ctx.viewState !== 'collapsed']
    ]),
    _withDirectives(_createElementVNode("div", {
      ref: "messageList",
      class: "group-chat__messages",
      onScroll: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
    }, [
      (_ctx.loadingOlder)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Loading older messages… "))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, "Loading…"))
        : _createCommentVNode("", true),
      (!_ctx.loading && _ctx.messages.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, " No chat history yet "))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.messages, (msg) => {
        return (_openBlock(), _createElementBlock("div", {
          key: msg.id,
          class: _normalizeClass(["group-chat__bubble", {
          'group-chat__bubble--event':
            msg.messageType === _ctx.GroupChatMessageType.UserLeft,
          'group-chat__bubble--own': msg.userId === _ctx.currentUserId,
          'group-chat__bubble--bot': msg.userId === 'system|propipe-ai',
        }])
        }, [
          (msg.messageType === _ctx.GroupChatMessageType.UserLeft)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_q_icon, {
                  name: "logout",
                  size: "14px",
                  class: "q-mr-xs"
                }),
                _createElementVNode("span", null, _toDisplayString(msg.text), 1),
                _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.formatTime(msg.timestamp)), 1)
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createElementVNode("div", _hoisted_9, [
                  (msg.userId === 'system|propipe-ai')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_10, [...(_cache[31] || (_cache[31] = [
                        _createElementVNode("img", {
                          src: _imports_0,
                          class: "group-chat__bot-icon"
                        }, null, -1),
                        _createTextVNode(" Propipe AI ", -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(msg.userName), 1)),
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.formatTime(msg.timestamp)), 1),
                  (_ctx.canModerateMessage(msg))
                    ? (_openBlock(), _createBlock(_component_q_btn, {
                        key: 2,
                        flat: "",
                        dense: "",
                        round: "",
                        icon: "more_vert",
                        size: "xs",
                        color: "grey-6",
                        class: "group-chat__delete",
                        title: "Message actions",
                        "aria-label": "Message actions"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_menu, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_list, { dense: "" }, {
                                default: _withCtx(() => [
                                  (msg.userId === _ctx.currentUserId)
                                    ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                        key: 0,
                                        clickable: "",
                                        onClick: ($event: any) => (_ctx.requestDelete(msg.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, { avatar: "" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_q_icon, { name: "delete_outline" })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_q_item_section, null, {
                                            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                                              _createTextVNode("Delete", -1)
                                            ]))]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])), [
                                        [_directive_close_popup]
                                      ])
                                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                        (msg.userId !== 'system|propipe-ai')
                                          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                              key: 0,
                                              clickable: "",
                                              onClick: ($event: any) => (_ctx.openReport(msg))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_icon, { name: "flag" })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_q_item_section, null, {
                                                  default: _withCtx(() => [...(_cache[33] || (_cache[33] = [
                                                    _createTextVNode("Report", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])), [
                                              [_directive_close_popup]
                                            ])
                                          : _createCommentVNode("", true),
                                        (!msg.userId.startsWith('system|'))
                                          ? _withDirectives((_openBlock(), _createBlock(_component_q_item, {
                                              key: 1,
                                              clickable: "",
                                              onClick: ($event: any) => (_ctx.openBlock(msg))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_q_item_section, { avatar: "" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_icon, { name: "block" })
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_q_item_section, null, {
                                                  default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                                    _createTextVNode("Block user", -1)
                                                  ]))]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["onClick"])), [
                                              [_directive_close_popup]
                                            ])
                                          : _createCommentVNode("", true)
                                      ], 64))
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    : _createCommentVNode("", true)
                ]),
                (msg.text)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (msg.userId === 'system|propipe-ai')
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "group-chat__markdown",
                            innerHTML: _ctx.renderMarkdown(msg.text)
                          }, null, 8, _hoisted_14))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.tokenizeMessageMentions(msg.text), (segment, index) => {
                            return (_openBlock(), _createElementBlock(_Fragment, {
                              key: `${msg.id}-${index}`
                            }, [
                              (segment.isMention)
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: _normalizeClass(["group-chat__mention", _ctx.mentionClass(segment.target)])
                                  }, _toDisplayString(segment.text), 3))
                                : (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(segment.text), 1))
                            ], 64))
                          }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (
              msg.userId === 'system|propipe-ai' &&
              msg.citations &&
              msg.citations.length > 0
            )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _cache[35] || (_cache[35] = _createElementVNode("span", { class: "group-chat__sources-label" }, "Sources", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(msg.citations, (citation) => {
                        return (_openBlock(), _createBlock(_component_q_btn, {
                          key: `${msg.id}-${citation.referenceId}`,
                          flat: "",
                          dense: "",
                          "no-caps": "",
                          icon: "open_in_new",
                          label: _ctx.formatCitationLabel(citation),
                          class: "group-chat__source-button",
                          title: "Open support document",
                          onClick: ($event: any) => (_ctx.openSupportSource(msg.id, citation))
                        }, null, 8, ["label", "onClick"]))
                      }), 128))
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visibleProposals(msg), (proposal) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: `${msg.id}-${proposal.actionId}`,
                    class: "group-chat__action"
                  }, [
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_q_icon, {
                        name: "settings_remote",
                        size: "16px"
                      }),
                      _cache[36] || (_cache[36] = _createElementVNode("span", { class: "group-chat__action-title" }, "Suggested command", -1)),
                      _createVNode(_component_q_badge, {
                        outline: "",
                        color: 
                  _ctx.describeProposalTransport(proposal) === 'Iridium'
                    ? 'orange-8'
                    : 'blue-7'
                ,
                        label: _ctx.describeProposalTransport(proposal)
                      }, null, 8, ["color", "label"])
                    ]),
                    _createElementVNode("div", _hoisted_18, _toDisplayString(proposal.summary), 1),
                    (_ctx.isProposalExecuted(msg, proposal))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                          _createVNode(_component_q_icon, {
                            name: "check_circle",
                            size: "14px"
                          }),
                          _cache[37] || (_cache[37] = _createTextVNode(" Sent ", -1))
                        ]))
                      : (_ctx.isProposalCancelled(msg, proposal))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                            _createVNode(_component_q_icon, {
                              name: "cancel",
                              size: "14px"
                            }),
                            _cache[38] || (_cache[38] = _createTextVNode(" Canceled ", -1))
                          ]))
                        : (_ctx.isProposalExpired(proposal))
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createVNode(_component_q_icon, {
                                name: "schedule",
                                size: "14px"
                              }),
                              _cache[39] || (_cache[39] = _createTextVNode(" Expired. Ask Propipe AI again for an up-to-date suggestion. ", -1))
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                              (!_ctx.proposalDetail(msg, proposal))
                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                    _createVNode(_component_q_btn, {
                                      unelevated: "",
                                      dense: "",
                                      "no-caps": "",
                                      color: "primary",
                                      label: "Review settings",
                                      loading: _ctx.loadingDetailKey === _ctx.actionKey(msg, proposal),
                                      onClick: ($event: any) => (_ctx.openProposal(msg, proposal))
                                    }, null, 8, ["loading", "onClick"]),
                                    _createVNode(_component_q_btn, {
                                      flat: "",
                                      dense: "",
                                      "no-caps": "",
                                      color: "grey-7",
                                      label: "Cancel",
                                      loading: _ctx.cancellingActionId === proposal.actionId,
                                      disable: _ctx.isProposalBusy(msg, proposal),
                                      onClick: ($event: any) => (_ctx.cancelProposal(msg, proposal))
                                    }, null, 8, ["loading", "disable", "onClick"])
                                  ]))
                                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proposalDetail(msg, proposal).warnings, (warning) => {
                                      return (_openBlock(), _createElementBlock("div", {
                                        key: warning,
                                        class: "group-chat__action-warning"
                                      }, [
                                        _createVNode(_component_q_icon, {
                                          name: "warning",
                                          size: "14px"
                                        }),
                                        _createTextVNode(" " + _toDisplayString(warning), 1)
                                      ]))
                                    }), 128)),
                                    _cache[43] || (_cache[43] = _createElementVNode("div", { class: "group-chat__action-section" }, [
                                      _createTextVNode(" Devices "),
                                      _createElementVNode("span", { class: "group-chat__action-hint" }, " unticking one leaves it out; none can be added ")
                                    ], -1)),
                                    _createElementVNode("div", _hoisted_23, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proposalDetail(msg, proposal).targets, (target) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: target.uid,
                                          class: "group-chat__action-device"
                                        }, [
                                          _createVNode(_component_q_checkbox, {
                                            dense: "",
                                            size: "xs",
                                            "model-value": _ctx.isTargetSelected(msg, proposal, target.uid),
                                            disable: 
                        _ctx.isOnlySelectedTarget(msg, proposal, target.uid) ||
                        _ctx.isProposalBusy(msg, proposal)
                      ,
                                            label: String(target.uid),
                                            "onUpdate:modelValue": ($event: any) => (
                        _ctx.toggleTarget(msg, proposal, target.uid)
                      )
                                          }, null, 8, ["model-value", "disable", "label", "onUpdate:modelValue"]),
                                          (!target.isConnected)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_24, "offline"))
                                            : _createCommentVNode("", true),
                                          (target.pendingCommandCount > 0)
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(target.pendingCommandCount) + " queued", 1))
                                            : _createCommentVNode("", true)
                                        ]))
                                      }), 128))
                                    ]),
                                    _cache[44] || (_cache[44] = _createElementVNode("div", { class: "group-chat__action-section" }, " Settings this command writes ", -1)),
                                    _createElementVNode("table", _hoisted_26, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.proposalDetail(msg, proposal).fields, (field) => {
                                        return (_openBlock(), _createElementBlock("tr", {
                                          key: field.fieldKey || field.label,
                                          class: _normalizeClass({
                      'group-chat__action-field--carried':
                        field.isCarriedForward,
                    })
                                        }, [
                                          _createElementVNode("td", _hoisted_27, [
                                            _createTextVNode(_toDisplayString(field.label) + " ", 1),
                                            (field.isCarriedForward)
                                              ? (_openBlock(), _createBlock(_component_q_icon, {
                                                  key: 0,
                                                  name: "lock_outline",
                                                  size: "11px"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_q_tooltip, null, {
                                                      default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                                                        _createTextVNode(" Not part of the request. This command cannot write less, so the device's own value is written back. ", -1)
                                                      ]))]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("td", _hoisted_28, _toDisplayString(field.currentDisplay), 1),
                                          _cache[41] || (_cache[41] = _createElementVNode("td", { class: "group-chat__action-field-arrow" }, "→", -1)),
                                          _createElementVNode("td", {
                                            class: _normalizeClass(["group-chat__action-field-new", {
                        'group-chat__action-field-new--changed':
                          field.isChanged,
                      }])
                                          }, [
                                            (field.choices && field.choices.length > 0)
                                              ? (_openBlock(), _createBlock(_component_q_select, {
                                                  key: 0,
                                                  dense: "",
                                                  outlined: "",
                                                  "emit-value": "",
                                                  "map-options": "",
                                                  "option-value": "value",
                                                  "option-label": "label",
                                                  options: field.choices,
                                                  "model-value": _ctx.fieldValue(msg, proposal, field),
                                                  disable: _ctx.isProposalBusy(msg, proposal),
                                                  class: "group-chat__action-field-input",
                                                  "onUpdate:modelValue": 
                          (value) => _ctx.editField(msg, proposal, field, value)
                        
                                                }, null, 8, ["options", "model-value", "disable", "onUpdate:modelValue"]))
                                              : (field.editor === 'elfFrequency')
                                                ? (_openBlock(), _createBlock(_component_q_input, {
                                                    key: 1,
                                                    dense: "",
                                                    outlined: "",
                                                    type: "number",
                                                    suffix: "Hz",
                                                    debounce: "700",
                                                    "model-value": _ctx.fieldValue(msg, proposal, field),
                                                    disable: _ctx.isProposalBusy(msg, proposal),
                                                    class: "group-chat__action-field-input",
                                                    "onUpdate:modelValue": 
                          (value) => _ctx.editField(msg, proposal, field, value)
                        
                                                  }, null, 8, ["model-value", "disable", "onUpdate:modelValue"]))
                                                : (_openBlock(), _createElementBlock("span", _hoisted_29, _toDisplayString(field.newDisplay), 1))
                                          ], 2)
                                        ], 2))
                                      }), 128))
                                    ]),
                                    (_ctx.proposalDetail(msg, proposal).requiresTypedConfirmation)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                          _cache[42] || (_cache[42] = _createElementVNode("div", { class: "group-chat__action-warning" }, " This cannot be undone from here. Type SEND to confirm. ", -1)),
                                          _createVNode(_component_q_input, {
                                            modelValue: _ctx.typedConfirmations[_ctx.actionKey(msg, proposal)],
                                            "onUpdate:modelValue": ($event: any) => ((_ctx.typedConfirmations[_ctx.actionKey(msg, proposal)]) = $event),
                                            dense: "",
                                            outlined: "",
                                            placeholder: "SEND",
                                            class: "group-chat__action-typed-input"
                                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                                        ]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_31, [
                                      _createVNode(_component_q_btn, {
                                        unelevated: "",
                                        dense: "",
                                        "no-caps": "",
                                        color: "primary",
                                        label: "Send command",
                                        disable: !_ctx.canSendProposal(msg, proposal),
                                        loading: _ctx.confirmingActionId === proposal.actionId,
                                        onClick: ($event: any) => (_ctx.confirmProposal(msg, proposal))
                                      }, null, 8, ["disable", "loading", "onClick"]),
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        dense: "",
                                        "no-caps": "",
                                        color: "grey-7",
                                        label: "Dismiss",
                                        disable: _ctx.isProposalBusy(msg, proposal),
                                        onClick: ($event: any) => (_ctx.dismissProposal(msg, proposal))
                                      }, null, 8, ["disable", "onClick"]),
                                      _createVNode(_component_q_btn, {
                                        flat: "",
                                        dense: "",
                                        "no-caps": "",
                                        color: "negative",
                                        label: "Cancel",
                                        loading: _ctx.cancellingActionId === proposal.actionId,
                                        disable: _ctx.isProposalBusy(msg, proposal),
                                        onClick: ($event: any) => (_ctx.cancelProposal(msg, proposal))
                                      }, null, 8, ["loading", "disable", "onClick"])
                                    ])
                                  ], 64))
                            ], 64)),
                    (_ctx.actionErrors[_ctx.actionKey(msg, proposal)])
                      ? (_openBlock(), _createElementBlock("div", _hoisted_32, _toDisplayString(_ctx.actionErrors[_ctx.actionKey(msg, proposal)]), 1))
                      : _createCommentVNode("", true)
                  ]))
                }), 128)),
                (msg.attachment)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                      (
                msg.attachment.contentType &&
                msg.attachment.contentType.startsWith('image/')
              )
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _withDirectives(_createElementVNode("img", {
                              alt: msg.attachment.originalName,
                              class: "group-chat__attachment-image",
                              style: {"cursor":"zoom-in"},
                              src: _ctx.attachmentUrls[msg.attachment.blobName] || '',
                              onClick: ($event: any) => (
                  _ctx.openImagePreview(
                    msg.attachment.blobName,
                    msg.attachment.originalName
                  )
                )
                            }, null, 8, _hoisted_34), [
                              [_vShow, _ctx.attachmentUrls[msg.attachment.blobName]]
                            ]),
                            (_ctx.attachmentErrors[msg.attachment.blobName])
                              ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                  _createElementVNode("span", null, _toDisplayString(_ctx.attachmentErrors[msg.attachment.blobName].message), 1),
                                  (_ctx.attachmentErrors[msg.attachment.blobName].canRetry)
                                    ? (_openBlock(), _createBlock(_component_q_btn, {
                                        key: 0,
                                        flat: "",
                                        dense: "",
                                        label: "Retry image",
                                        onClick: ($event: any) => (_ctx.retryImageAttachment(msg.attachment.blobName))
                                      }, null, 8, ["onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (!_ctx.attachmentUrls[msg.attachment.blobName])
                                ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                                    _createVNode(_component_q_spinner, { size: "16px" }),
                                    _cache[45] || (_cache[45] = _createTextVNode(" Loading image... ", -1))
                                  ]))
                                : _createCommentVNode("", true)
                          ], 64))
                        : (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "group-chat__attachment-file",
                            onClick: ($event: any) => (
                  _ctx.downloadAttachment(
                    msg.attachment.blobName,
                    msg.attachment.originalName
                  )
                )
                          }, [
                            _createVNode(_component_q_icon, {
                              name: "attach_file",
                              size: "16px",
                              class: "q-mr-xs"
                            }),
                            _createElementVNode("span", {
                              class: "group-chat__attachment-name",
                              title: msg.attachment.originalName
                            }, _toDisplayString(msg.attachment.originalName), 9, _hoisted_38),
                            _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.formatFileSize(msg.attachment.sizeBytes)), 1)
                          ], 8, _hoisted_37))
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.getReactions(msg.id).length > 0 || true)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getReactions(msg.id), (r) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: r.emoji,
                          class: _normalizeClass(["group-chat__reaction-chip", {
                'group-chat__reaction-chip--mine':
                  r.userIds.includes(_ctx.currentUserId),
              }]),
                          title: r.userIds.length + ' reaction(s)',
                          onClick: ($event: any) => (_ctx.toggleReaction(msg.id, r.emoji))
                        }, [
                          _createTextVNode(_toDisplayString(r.emoji) + " ", 1),
                          _createElementVNode("span", _hoisted_42, _toDisplayString(r.userIds.length), 1)
                        ], 10, _hoisted_41))
                      }), 128)),
                      _createElementVNode("span", {
                        class: "group-chat__reaction-add",
                        title: "Add reaction",
                        onClick: _withModifiers(($event: any) => (_ctx.openEmojiPicker($event, msg.id)), ["stop"])
                      }, "😀+", 8, _hoisted_43)
                    ]))
                  : _createCommentVNode("", true)
              ], 64))
        ], 2))
      }), 128)),
      (_ctx.someoneTyping)
        ? (_openBlock(), _createElementBlock("div", _hoisted_44, [...(_cache[46] || (_cache[46] = [
            _createElementVNode("span", null, "Someone is typing", -1),
            _createElementVNode("span", { class: "typing-dots" }, [
              _createElementVNode("span"),
              _createElementVNode("span"),
              _createElementVNode("span")
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      (_ctx.propipeQueryPending)
        ? (_openBlock(), _createElementBlock("div", _hoisted_45, [...(_cache[47] || (_cache[47] = [
            _createStaticVNode("<div class=\"group-chat__meta\" data-v-640bac93><span class=\"group-chat__author group-chat__author--bot\" data-v-640bac93><img src=\"" + _imports_0 + "\" class=\"group-chat__bot-icon\" data-v-640bac93> Propipe AI </span></div><div class=\"group-chat__text group-chat__thinking\" data-v-640bac93> Thinking<span class=\"thinking-dot1\" data-v-640bac93>.</span><span class=\"thinking-dot2\" data-v-640bac93>.</span><span class=\"thinking-dot3\" data-v-640bac93>.</span></div>", 2)
          ]))]))
        : _createCommentVNode("", true)
    ], 544), [
      [_vShow, _ctx.viewState !== 'collapsed']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_46, [
      (_ctx.chatSuspended)
        ? (_openBlock(), _createElementBlock("div", _hoisted_47, " Your chat access is unavailable. Your other features remain available. "))
        : _createCommentVNode("", true),
      (_ctx.chatError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
            _createElementVNode("span", null, _toDisplayString(_ctx.chatError), 1),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              round: "",
              icon: "close",
              size: "xs",
              "aria-label": "Dismiss",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.chatError = ''))
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.chatNotice)
        ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
            _createElementVNode("span", null, _toDisplayString(_ctx.chatNotice), 1),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              round: "",
              icon: "close",
              size: "xs",
              "aria-label": "Dismiss",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.chatNotice = ''))
            })
          ]))
        : _createCommentVNode("", true),
      (_ctx.pendingAttachment)
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            _createVNode(_component_q_icon, {
              name: "attach_file",
              size: "14px",
              class: "q-mr-xs"
            }),
            _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.pendingAttachment.originalName), 1),
            _createElementVNode("span", _hoisted_52, _toDisplayString(_ctx.formatFileSize(_ctx.pendingAttachment.sizeBytes)), 1),
            _createVNode(_component_q_btn, {
              flat: "",
              dense: "",
              round: "",
              icon: "close",
              size: "xs",
              disable: _ctx.sending,
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.pendingAttachment = null))
            }, null, 8, ["disable"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.uploading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_53, [
            _createVNode(_component_q_spinner, {
              size: "14px",
              class: "q-mr-xs"
            }),
            _cache[48] || (_cache[48] = _createElementVNode("span", null, "Uploading...", -1))
          ]))
        : _createCommentVNode("", true),
      (_ctx.showAtMenu)
        ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.atMenuOptions, (option, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: option.target,
                class: _normalizeClass(["group-chat__at-option", {
            'group-chat__at-option--active': _ctx.atMenuActiveIndex === index,
          }]),
                onMousedown: _withModifiers(($event: any) => (_ctx.insertMention(option.target)), ["prevent"])
              }, [
                _cache[49] || (_cache[49] = _createElementVNode("img", {
                  src: _imports_0,
                  style: {"width":"16px","height":"16px","margin-right":"6px"}
                }, null, -1)),
                _createElementVNode("span", null, [
                  _createElementVNode("strong", null, _toDisplayString(option.mention), 1),
                  _createTextVNode(" — " + _toDisplayString(option.description), 1)
                ])
              ], 42, _hoisted_55))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_q_input, {
        ref: "chatInput",
        modelValue: _ctx.draft,
        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.draft) = $event)),
        dense: "",
        outlined: "",
        placeholder: "Type a message…",
        class: "group-chat__field",
        maxlength: "2000",
        disable: _ctx.chatSuspended,
        error: _ctx.isOverLimit,
        "error-message": `Message exceeds ${2000} characters`,
        "hide-bottom-space": "",
        onKeydown: _ctx.onInputKeydown,
        onPaste: _ctx.onPaste
      }, {
        append: _withCtx(() => [
          (_ctx.draft.length > 1800)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["group-chat__char-count", { 'group-chat__char-count--over': _ctx.isOverLimit }])
              }, _toDisplayString(_ctx.charsRemaining), 3))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: "group-chat__emoji-btn",
            title: "Insert emoji",
            onClick: _cache[12] || (_cache[12] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openInputEmojiPicker && _ctx.openInputEmojiPicker(...args)), ["stop"]))
          }, "😀"),
          _createVNode(_component_q_btn, {
            flat: "",
            dense: "",
            round: "",
            icon: "attach_file",
            size: "sm",
            title: "Attach file",
            "aria-label": "Attach file",
            disable: _ctx.uploading || _ctx.chatSuspended,
            onClick: _ctx.triggerFileInput
          }, null, 8, ["disable", "onClick"]),
          _createVNode(_component_q_btn, {
            flat: "",
            dense: "",
            round: "",
            icon: "send",
            color: "primary",
            disable: 
              (!_ctx.draft.trim() && !_ctx.pendingAttachment) ||
              _ctx.uploading ||
              _ctx.isOverLimit ||
              _ctx.chatSuspended ||
              !_ctx.activeConversationId
            ,
            onClick: _ctx.send
          }, null, 8, ["disable", "onClick"])
        ]),
        _: 1
      }, 8, ["modelValue", "disable", "error", "onKeydown", "onPaste"]),
      _createElementVNode("input", {
        ref: "fileInput",
        type: "file",
        style: {"display":"none"},
        accept: ".jpg,.jpeg,.png,.pdf,.docx,.xlsx,.pptx,.csv,.agm,.onl,.onlv,.agmv,.ofl,.zip,.text,.txt,.md,.json,.xml",
        onChange: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
      }, null, 544)
    ], 512), [
      [_vShow, _ctx.viewState !== 'collapsed']
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.lightboxOpen)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "group-chat__lightbox-overlay",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.lightboxOpen = false))
          }, [
            _createElementVNode("div", {
              class: "group-chat__lightbox",
              onClick: _cache[17] || (_cache[17] = _withModifiers(() => {}, ["stop"]))
            }, [
              _createElementVNode("img", {
                src: _ctx.lightboxSrc,
                alt: _ctx.lightboxAlt,
                class: "group-chat__lightbox-img"
              }, null, 8, _hoisted_56),
              (_ctx.lightboxLoading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                    _createVNode(_component_q_spinner, { size: "16px" }),
                    _cache[50] || (_cache[50] = _createTextVNode(" Loading full-resolution image... ", -1))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.lightboxError)
                ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                    _createTextVNode(_toDisplayString(_ctx.lightboxError) + " ", 1),
                    (_ctx.lightboxErrorCanRetry)
                      ? (_openBlock(), _createBlock(_component_q_btn, {
                          key: 0,
                          flat: "",
                          dense: "",
                          label: "Retry full-resolution image",
                          onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.openImagePreview(_ctx.lightboxBlobName, _ctx.lightboxAlt)))
                        }))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_59, [
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "download",
                  color: "white",
                  title: "Download",
                  disable: _ctx.lightboxLoading || !_ctx.lightboxOriginalUrl,
                  onClick: _ctx.downloadLightboxImage
                }, null, 8, ["disable", "onClick"]),
                _createVNode(_component_q_btn, {
                  flat: "",
                  dense: "",
                  round: "",
                  icon: "close",
                  color: "white",
                  title: "Close",
                  onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.lightboxOpen = false))
                })
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (_ctx.emojiPickerOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "group-chat__emoji-overlay",
          onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.emojiPickerOpen = false))
        }, [
          _createElementVNode("div", {
            class: "group-chat__emoji-picker",
            style: _normalizeStyle({ bottom: _ctx.emojiPickerBottom + 'px', right: '8px' }),
            onClick: _cache[19] || (_cache[19] = _withModifiers(() => {}, ["stop"]))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.emojiOptions, (e) => {
              return (_openBlock(), _createElementBlock("span", {
                key: e,
                class: "group-chat__emoji-option",
                onClick: ($event: any) => (_ctx.onEmojiSelected(e))
              }, _toDisplayString(e), 9, _hoisted_60))
            }), 128))
          ], 4)
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.reportDialog,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.reportDialog) = $event)),
      persistent: _ctx.moderationBusy
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"420px","max-width":"92vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_form, {
              onSubmit: _withModifiers(_ctx.submitReport, ["prevent"])
            }, {
              default: _withCtx(() => [
                _createVNode(_component_q_card_section, { class: "text-h6" }, {
                  default: _withCtx(() => [...(_cache[51] || (_cache[51] = [
                    _createTextVNode("Report message", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_select, {
                      modelValue: _ctx.reportReason,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.reportReason) = $event)),
                      options: _ctx.reportReasons,
                      "emit-value": "",
                      "map-options": "",
                      outlined: "",
                      label: "Reason",
                      disable: _ctx.moderationBusy
                    }, null, 8, ["modelValue", "options", "disable"]),
                    _createVNode(_component_q_input, {
                      modelValue: _ctx.reportNotes,
                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.reportNotes) = $event)),
                      type: "textarea",
                      outlined: "",
                      label: "Additional details (optional)",
                      maxlength: "1000",
                      counter: "",
                      class: "q-mt-md",
                      disable: _ctx.moderationBusy
                    }, null, 8, ["modelValue", "disable"]),
                    (_ctx.moderationError)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString(_ctx.moderationError), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_q_card_actions, { align: "right" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      flat: "",
                      label: "Cancel",
                      disable: _ctx.moderationBusy
                    }, null, 8, ["disable"]), [
                      [_directive_close_popup]
                    ]),
                    _createVNode(_component_q_btn, {
                      type: "submit",
                      color: "primary",
                      label: "Submit report",
                      disable: !_ctx.reportReason,
                      loading: _ctx.moderationBusy
                    }, null, 8, ["disable", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["onSubmit"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "persistent"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.blockDialog,
      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.blockDialog) = $event)),
      persistent: _ctx.moderationBusy
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"420px","max-width":"92vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "text-h6" }, {
              default: _withCtx(() => [
                _createTextVNode("Block " + _toDisplayString(_ctx.blockTarget?.userName) + "?", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _cache[52] || (_cache[52] = _createTextVNode(" You will no longer see each other's messages in company chats. Direct chat will be unavailable. Other participants can still see those messages. ", -1)),
                (_ctx.moderationError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_62, _toDisplayString(_ctx.moderationError), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "Cancel",
                  disable: _ctx.moderationBusy
                }, null, 8, ["disable"]), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_btn, {
                  color: "negative",
                  icon: "block",
                  label: "Block user",
                  loading: _ctx.moderationBusy,
                  onClick: _ctx.confirmBlock
                }, null, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "persistent"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.blockedUsersDialog,
      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.blockedUsersDialog) = $event)),
      persistent: _ctx.moderationBusy
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"420px","max-width":"92vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "row items-center" }, {
              default: _withCtx(() => [
                _cache[53] || (_cache[53] = _createElementVNode("div", { class: "text-h6" }, "Blocked users", -1)),
                _createVNode(_component_q_space),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close",
                  "aria-label": "Close",
                  disable: _ctx.moderationBusy
                }, null, 8, ["disable"]), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, {
              class: "q-pt-none",
              style: {"max-height":"60vh","overflow":"auto"}
            }, {
              default: _withCtx(() => [
                (_ctx.blocksLoading)
                  ? (_openBlock(), _createBlock(_component_q_linear_progress, {
                      key: 0,
                      indeterminate: ""
                    }))
                  : _createCommentVNode("", true),
                (_ctx.blocksError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                      _createTextVNode(_toDisplayString(_ctx.blocksError) + " ", 1),
                      _createVNode(_component_q_btn, {
                        flat: "",
                        icon: "refresh",
                        label: "Retry",
                        disable: _ctx.blocksLoading,
                        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.loadBlocks(_ctx.blockPage)))
                      }, null, 8, ["disable"])
                    ]))
                  : (!_ctx.blocksLoading && !_ctx.blockedUsers.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_64, " No blocked users "))
                    : _createCommentVNode("", true),
                _createVNode(_component_q_list, { separator: "" }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.blockedUsers, (user) => {
                      return (_openBlock(), _createBlock(_component_q_item, {
                        key: user.userId
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_item_section, { style: {"overflow-wrap":"anywhere"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(user.userName), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(_component_q_item_section, { side: "" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_btn, {
                                flat: "",
                                color: "primary",
                                label: "Unblock",
                                disable: _ctx.moderationBusy || _ctx.blocksLoading,
                                onClick: ($event: any) => (_ctx.unblockUser(user.userId))
                              }, null, 8, ["disable", "onClick"])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  icon: "chevron_left",
                  title: "Previous page",
                  disable: _ctx.blockPage === 0 || _ctx.blocksLoading || _ctx.moderationBusy,
                  onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.loadBlocks(_ctx.blockPage - 1)))
                }, null, 8, ["disable"]),
                _createElementVNode("span", null, _toDisplayString(_ctx.blockPage + 1) + " / " + _toDisplayString(Math.max(1, Math.ceil(_ctx.blockTotal / 50))), 1),
                _createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  icon: "chevron_right",
                  title: "Next page",
                  disable: 
              (_ctx.blockPage + 1) * 50 >= _ctx.blockTotal ||
              _ctx.blocksLoading ||
              _ctx.moderationBusy
            ,
                  onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.loadBlocks(_ctx.blockPage + 1)))
                }, null, 8, ["disable"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "persistent"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.deleteDialog,
      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.deleteDialog) = $event)),
      persistent: _ctx.moderationBusy
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"360px","max-width":"92vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_card_section, { class: "text-h6" }, {
              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                _createTextVNode("Delete message?", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_q_card_section, { class: "q-pt-none" }, {
              default: _withCtx(() => [
                _cache[55] || (_cache[55] = _createTextVNode("The message and its image will be removed from chat. ", -1)),
                (_ctx.moderationError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_65, _toDisplayString(_ctx.moderationError), 1))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_actions, { align: "right" }, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  label: "Cancel",
                  disable: _ctx.moderationBusy
                }, null, 8, ["disable"]), [
                  [_directive_close_popup]
                ]),
                _createVNode(_component_q_btn, {
                  color: "negative",
                  label: "Delete",
                  loading: _ctx.moderationBusy,
                  onClick: _ctx.deleteMessage
                }, null, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "persistent"]),
    _createVNode(_component_q_dialog, {
      modelValue: _ctx.leaveConfirmDialog,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.leaveConfirmDialog) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_q_card, { style: {"width":"320px","max-width":"90vw"} }, {
          default: _withCtx(() => [
            _createVNode(_component_q_toolbar, null, {
              default: _withCtx(() => [
                _createVNode(_component_q_toolbar_title, { class: "text-blue-brand text-bold" }, {
                  default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                    _createTextVNode(" Leave Conversation ", -1)
                  ]))]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_q_btn, {
                  flat: "",
                  round: "",
                  dense: "",
                  icon: "close"
                }, null, 512), [
                  [_directive_close_popup]
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_q_card_section, null, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_66, [
                  _createElementVNode("div", _hoisted_67, "Leave " + _toDisplayString(_ctx.leaveConversationLabel) + "?", 1)
                ]),
                _createVNode(_component_q_separator),
                _createVNode(_component_q_card_actions, { align: "center" }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "No",
                      "no-caps": ""
                    }, null, 512), [
                      [_directive_close_popup]
                    ]),
                    _withDirectives(_createVNode(_component_q_btn, {
                      class: "btn-brand",
                      label: "Yes-Leave",
                      "no-caps": "",
                      onClick: _ctx.confirmLeaveConversation
                    }, null, 8, ["onClick"]), [
                      [_directive_close_popup]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 6))
}